// extracted by mini-css-extract-plugin
module.exports = {"button":"ButtonBase_button__2A3ua","normal":"ButtonBase_normal__1uBjD","large":"ButtonBase_large__YlDsz","full-width":"ButtonBase_full-width__1iJBO"};